import React, { useContext, useEffect, useState } from 'react';
import { MautBoxRegistration, Wrapper, Head, HintMessage, ContentWrapper } from '@adac-mp/components';
import { DkvContext, OfferContext, ICountry, IOfferContext, getCountriesByCustomer } from '@adac-mp/shared';

interface IRegistrationProps {
	hasError?: boolean;
	updateValidatedStepsMap?: (hasError: boolean, reset?: boolean) => void;
}

const Registration = ({ hasError, updateValidatedStepsMap = () => {} }: IRegistrationProps) => {
	const { inputFields, vehicleDataFilled, vehicleRegistration, updateInputFields, updateVehicleDataFilled } =
		useContext(DkvContext);
	const { allCountries, offer } = useContext<IOfferContext>(OfferContext);
	const customerCountries = offer?.customerCountries ?? [];
	const [countries, setCountries] = useState<ICountry[] | []>([]);

	useEffect(() => {
		updateValidatedStepsMap(Boolean(vehicleDataFilled && vehicleRegistration));
		return () => {
			//case when a user deletes the image and uploads a new one
			updateValidatedStepsMap(true);
		};
	}, [vehicleDataFilled, vehicleRegistration]);

	useEffect(() => {
		if (allCountries && customerCountries) {
			const countriesByCustomer = getCountriesByCustomer(allCountries, customerCountries);
			setCountries(countriesByCustomer);
		}
	}, [allCountries, offer]);

	return (
		<Wrapper animate>
			<Head
				headline="Daten prüfen"
				description="Bitte geben Sie hier die benötigten Daten aus Ihrer Zulassungsbescheinigung ein bzw. prüfen Sie die aus dem hochgeladenen Foto übernommenen Angaben vor dem Absenden auf Richtigkeit und Vollständigkeit. Beachten Sie bitte die Hinweise in den Feldern – bei Länge keine dreistellige Zahl eingeben und bei Breite und Höhe weder eine dreistellige noch eine fünfstellige Zahl eingeben (da Angabe in Millimeter)."
			/>
			<ContentWrapper>
				{hasError && (
					<HintMessage
						className="mb-5"
						variant="error"
						hints={[
							{
								message: 'Bitte prüfen Sie, ob alle Eingabefelder korrekt ausgefüllt sind',
							},
						]}
					/>
				)}
				{countries.length > 0 && (
					<MautBoxRegistration
						hasError={hasError}
						inputFields={inputFields}
						countries={countries}
						updateInputFields={updateInputFields}
						updateVehicleDataFilled={updateVehicleDataFilled}
					/>
				)}
			</ContentWrapper>
		</Wrapper>
	);
};

export default Registration;
